// src/pages/AIFluencyPage.js
import React from 'react';
import './AIFluencyPage.css';

export function AIFluencyPage() {
  return (
    <div className="ai-fluency-page">
      <div className="container">
        <div className="page-header">
          <h1>AI Fluency Initiative</h1>
          <p className="subtitle">The Ohio State University's Commitment to AI Fluency</p>
        </div>

        <div className="video-section">
          <h2>Learn About AI Fluency at Ohio State</h2>
          <div className="video-container">
            {/* Replace the placeholder iframe with your Mediasite embed */}
            <iframe 
              title="AI Fluency" 
              width="900" 
              height="600" 
              frameBorder="0" 
              scrolling="auto" 
              marginHeight="0" 
              marginWidth="0" 
              src="https://mediasite.osu.edu/Mediasite/Play/b563eec7e5fe499ca4f1af4b2037509e1d" 
              allowFullScreen 
              msallowfullscreen="true"
              allow="fullscreen"
            ></iframe>
          </div>
          <p className="video-disclaimer">
            <em>Note: This video overview was generated using Google's NotebookLM from content scraped from the <a href="https://oaa.osu.edu/ai-fluency" target="_blank" rel="noopener noreferrer">OSU AI Fluency website</a>.</em>
          </p>
        </div>

        <div className="key-components">
          <h2>Key Components of AI Fluency</h2>
          <ul className="components-list">
            <li>
              <strong>Foundational Understanding:</strong> Core concepts of AI, machine learning, 
              and their capabilities and limitations
            </li>
            <li>
              <strong>Practical Skills:</strong> Hands-on experience with AI tools relevant 
              to specific disciplines
            </li>
            <li>
              <strong>Ethical Framework:</strong> Understanding responsible AI use, bias 
              detection, and societal implications
            </li>
            <li>
              <strong>Critical Thinking:</strong> Ability to evaluate AI outputs, verify 
              information, and make informed decisions
            </li>
            <li>
              <strong>Collaborative Intelligence:</strong> Learning to work effectively 
              alongside AI systems as partners
            </li>
          </ul>
        </div>

        <div className="resources-section">
          <h2>Resources for Students</h2>
          <div className="resources-grid">
            <a 
              href="https://ai.osu.edu/resources-buckeyes"
              target="_blank"
              rel="noopener noreferrer"
              className="resource-link"
            >
              OSU AI Resources Hub
            </a>
            <a 
              href="/prompt-engineering"
              className="resource-link"
            >
              Prof. C's Prompt Engineering Guide
            </a>
            <a 
              href="/ethics"
              className="resource-link"
            >
              Prof. C's AI Ethics and Responsibility Guidelines
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
